import React from "react";
import Button from "@material-ui/core/Button";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import MuiAlert from "@material-ui/lab/Alert";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Copyright from "Components/Copyright";
import useError from "Hooks/useError";
import { message } from "constants/message";

import Axios from "axios";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "2.5em",
    color: "#556cd6",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  wrapper: {
    margin: theme.spacing(2),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(2),
  },
  toast: {
    width: "100%",
  },
  messsageWrapper: {
    marginTop: theme.spacing(2),
  },
}));

export default function SignIn(props) {
  const classes = useStyles();
  const stateError = useError();
  const messages = message();

  const [mail, setMail] = React.useState("");

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - パスワードリセット";
    
    stateError.initialize();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    Axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
    await Axios({
      method: "POST",
      url: "admin/authentication/reset_password",
      data: {
        email: mail,
      },
    }).then(() => {
      // メールを送信してログイン画面へ遷移
      props.history.push("/admin/?status=201");
    })
    .catch((error) => {
      stateError.dispatch({
        type: "set",
        payload: {
          isError: true,
          errorMsg: messages.validation.common,
        },
      });
    });
  };

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <h1 className={classes.title}>Buzz Finder Admin</h1>
        <Typography component="h1" variant="h5">
          パスワードリセット
        </Typography>

        <Typography component="p" variant="p" className={classes.wrapper}>
          パスワードをリセットします。
          <br />
          登録しているメールアドレスを入力してください。
        </Typography>
        <ValidatorForm 
          className={classes.form} 
          onSubmit={handleSubmit} 
          onError={onError}
          method="post"
        >
          <TextValidator
            variant="outlined"
            fullWidth
            id="email"
            label="メールアドレス*"
            name="email"
            autoFocus
            value={mail}
            onChange={(event) => {
              setMail(event.target.value);
            }}
            validators={['required', 'isEmail']}
            errorMessages={[
              messages.validation.required, 
              messages.validation.isEmail, 
            ]}
          />
          {stateError.state.isError && (
            <div className={classes.messsageWrapper}>
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="error"
                className={classes.toast}
              >
                {stateError.state.errorMsg}
              </MuiAlert>
            </div>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            送信する
          </Button>
        </ValidatorForm>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
